// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3WNE6","insightsList":"newBusinessInsightsMenu_insightsList__22n6O","active":"newBusinessInsightsMenu_active__2oS1d"};